import { useQuery } from '@tanstack/react-query';
import { client } from '../api';

export type FeatureFlags = {
  providerDemoFlow: boolean;
  providerSplitSignup: boolean;
  providerSignupFlow: boolean;
  providerOnboarding: boolean;
};

/**
 * Hook to fetch feature flags (non-practice specific) from the configuration service
 */
const defaultFeatureFlags: FeatureFlags = {
  providerSplitSignup: false,
  providerSignupFlow: false,
  providerDemoFlow: false,
  providerOnboarding: false,
};

export const useFeatureFlags = () => {
  return useQuery<FeatureFlags, Error>({
    queryKey: ['feature-flags'],
    queryFn: async () => {
      const response = await client.get<Record<string, boolean>>('feature-flags');
      const configs = response.data;

      const parsedConfigs = {
        providerSplitSignup: configs['provider-split-signup-feature-flag'] ?? false,
        providerDemoFlow: configs['provider-demo-flow-feature-flag'] ?? false,
        providerSignupFlow: configs['provider-signup-flow-feature-flag'] ?? false,
        providerOnboarding: configs['provider-onboarding-feature-flag'] ?? false,
      };
      return parsedConfigs;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnWindowFocus: false,
    select: (data) => data ?? defaultFeatureFlags,
  });
};
